"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = void 0;
var react_1 = __importDefault(require("react"));
var utils_1 = require("../utils");
var Label = function (_a) {
    var _b;
    var data = _a.data, _c = _a.pathVariables, height = _c.height, rx = _c.rx, ry = _c.ry, fixed = _c.fixed, textSize = _a.textSize, showLabelPercentage = _a.showLabelPercentage;
    var value = (data.percentageValue * 100).toFixed(fixed);
    var text = "".concat((_b = data.label) !== null && _b !== void 0 ? _b : '').concat(showLabelPercentage ? "(".concat(value, "%)") : '');
    var _d = (0, utils_1.createLabelPath)(data.middleAngle, rx, ry, height, (0, utils_1.getTextWidth)(text, textSize), textSize), path = _d.path, x = _d.x, y = _d.y;
    return (react_1.default.createElement("g", null,
        react_1.default.createElement("path", { d: path, stroke: "black", strokeWidth: "1", fill: 'none' }),
        react_1.default.createElement("text", { x: x, y: y, fontSize: textSize }, text)));
};
exports.Label = Label;
